import { modelOptions, prop, Severity } from '@typegoose/typegoose';

@modelOptions({
  options: {allowMixed: Severity.ALLOW},
  schemaOptions: {_id: false}
})
export class LearningStateModel {
  @prop({required: true})
  status: number;

  @prop({required: false})
  estimatedRemainingDays: number;

  @prop({required: false})
  targetUsersCount: number;

  @prop({required: false})
  progress: number;
}
